var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarbage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "garbage",
    transform: "translate(-160 -106.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 56,
    height: 408.471,
    rx: 28,
    transform: "translate(341.467 371.701)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 56,
    height: 408.471,
    rx: 28,
    transform: "translate(625.141 371.701)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 56,
    height: 408.471,
    rx: 28,
    transform: "translate(483.304 371.701)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M837.721,225.968v-.1H714.707v-63.7a56,56,0,0,0-56-56H365.9a56,56,0,0,0-56,56v63.7H188.565A28.565,28.565,0,0,0,160,254.434h0A28.565,28.565,0,0,0,188.565,283h23.576V822.423c0,52.69,39.4,95.4,88,95.4H718.924c48.6,0,88-42.714,88-95.4V283h30.8v-.1A28.561,28.561,0,0,0,864,254.434h0A28.561,28.561,0,0,0,837.721,225.968ZM363.087,172.173a16,16,0,0,1,16-16H639.978a16,16,0,0,1,16,16v53.7H363.087ZM750.1,803.79V821.2c0,19.16-14.327,34.693-32,34.693H301.576c-17.673,0-32-15.533-32-34.693V745.873h-.3V283H749.793V800.441A18.794,18.794,0,0,0,750.1,803.79Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarbage);
export default __webpack_public_path__ + "static/media/garbage.10881ed0.svg";
export { ForwardRef as ReactComponent };